( function ($) {
Drupal.behaviors.formTypeRadio = {
	attach: function(context, settings) {
		let radioCollection = document.querySelectorAll('.js-form-type-radio label');
		
		radioCollection.forEach(el => {
			let 
			radioField = el.parentNode,
			radio = el.previousElementSibling,
			checked = radio.checked,
			checkedClass = radio.classList;
		
			// console.log('before ' + checked)

			/*
			if (checked) {
				radio.setAttribute('checked', true);
			}*/
		
			if (checked === true) {
				radioField.classList.add('js-checked');
			}



			el.addEventListener('click', _label => {

				let siblings = n => [...radioField.parentNode.children].filter(c=>c.nodeType == 1 && c!=n);
			
				let fieldSiblings = siblings(radioField);
			
				fieldSiblings.forEach(e => e.classList.remove('js-checked'));
			
				radioField.classList.add('js-checked');
			
				/*
				if (checkedClass.contains('js-checked')) {
					checkedClass.remove('js-checked');
				} else {
				
				}*/

			});
		});
	}
};
})(jQuery);
